import { makeStyles } from '@mui/styles';
import palette from "../../utils/Theme/palette";

const useStyles = makeStyles({
    ordersContainer: {
        padding: '45px 52px'
    },
    orderHistoryTypo: {
        fontSize: '32px !important'
    },
    tabTanelContainer: {
        marginTop: '16px !important'
    }
});

export default useStyles;